export default "__VITE_ASSET__VEn7yTM9__"